module.exports = __webpack_public_path__ + "img/Number=5.2db78da5.png";